<div class="welcome d-flex flex-column" [formGroup]="welcomeMessageForm" style="font-size: 14px;">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h4 class="title">Welcome message</h4>
    <button class="btn btn-primary button btn-save btn-vernova" (click)="updateWelcomeMessage()">Save</button>
  </div>
  <div class="col-12 text-normal p-0">Title
    <span style="color: red;">*</span>
  </div>
  <mat-form-field appearance="outline">
    <input matInput required formControlName="title" placeholder="Enter Title" maxlength="100">
    <mat-hint align="end">{{welcomeMessageForm.controls.title.value?.length}} / 100</mat-hint>
    <mat-error>{{welcomeMessageForm.controls.title.errors?.message}}</mat-error>
  </mat-form-field>
  <div class="w-100 col-12 p-0">
    <div id="editor" style="height: 300px; background-color: #005E60;"></div>
    <mat-hint align="end" style="float: right; font-size: 75%;">{{quill?.getLength() - 1}} / {{limit}}</mat-hint>
    <mat-error style="font-size: 75%" *ngIf="!content">This field is required</mat-error>
  </div>
  <div class="col-12 text-normal p-0 mt-4 font-weight-bold">Avatar
  </div>
  <div class="persional row">
    <div class="col-md-3 col-xl-2 text-center">
      <div class="img d-flex align-items-center">
        <div *ngIf="loadingAvatar" class="d-flex align-items-center justify-content-center w-100 h-100">
          <div class="loader"></div>
        </div>
        <img [src]="avatarUrl.url" (click)="fileInputAva.click()" [hidden]="loadingAvatar" (load)="onLoadAvatar()"
          style="cursor: pointer;"> <br />
      </div>
      <button class="btn btn-primary button btn-vernova mt-3" (click)="remove('avatar')">Remove</button>
      <mat-error *ngIf="!avatarExist">No file chosen</mat-error>
      <input type='file' (change)="onSelectFile($event,'avatar')" hidden #fileInputAva accept=".png, .jpg, .jpeg">
    </div>
    <div class="col-md-9 col-xl-10">
      <div class="col-12 text-normal p-0">Name
        <span style="color: red;">*</span>
      </div>
      <mat-form-field appearance="outline" class=" w-100">
        <input matInput required formControlName="name" placeholder="Enter Name" maxlength="50">
        <mat-hint align="end">{{welcomeMessageForm.controls.name.value?.length}} / 50</mat-hint>
        <mat-error>{{welcomeMessageForm.controls.name.errors?.message}}</mat-error>
      </mat-form-field>
      <div class="col-12 text-normal p-0">Job Title
        <span style="color: red;">*</span>
      </div>
      <mat-form-field appearance="outline" class=" w-100">
        <input matInput required formControlName="jobTitle" placeholder="Enter Job title" maxlength="50">
        <mat-hint align="end">{{welcomeMessageForm.controls.jobTitle.value?.length}} / 50</mat-hint>
        <mat-error class="mt-2">{{welcomeMessageForm.controls.jobTitle.errors?.message}}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="col-12 text-normal p-0 font-weight-bold mt-4">Welcome Image
  </div>
  <div class="img-cover row">
    <div class="col-md-3 col-xl-2 text-center">
      <div class="img m-auto d-flex align-items-center">
        <div *ngIf="loading" class="d-flex align-items-center justify-content-center w-100 h-100">
          <div class="loader"></div>
        </div>
        <img [src]="welcomeImgUrl.url" (click)="fileInputImg.click()" style="cursor: pointer;" [hidden]="loading"
          (load)="onLoad()"> <br />
      </div>
      <button class="btn btn-primary button btn-vernova mt-3" (click)="remove('cover')">Remove</button>
      <input type='file' (change)="onSelectFile($event, 'cover')" hidden #fileInputImg accept=".png, .jpg, .jpeg">
      <mat-error *ngIf="!coverExist" class="mt-2">No file chosen</mat-error>
    </div>
    <div class="col-md-9 col-xl-10">
      <div class="preview">
        <div *ngIf="loading" class="d-flex align-items-center justify-content-center w-100 h-100">
          <div class="loader"></div>
        </div>
        <img [src]="coverImage" [hidden]="loading" (load)="onLoad()"> <br />
      </div>
    </div>
  </div>
</div>